import { gettext } from '@eventbrite/i18n';
import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { IFormikActions } from '../../../constants/interfaces';
import VerificationFormFields from './VerificationFormFields';

const VerificationSchema = Yup.object().shape({
    number1: Yup.number().required(),
    number2: Yup.number().required(),
    number3: Yup.number().required(),
    number4: Yup.number().required(),
    number5: Yup.number().required(),
    number6: Yup.number().required(),
});

export interface IVerificationValuesProps {
    number1: string;
    number2: string;
    number3: string;
    number4: string;
    number5: string;
    number6: string;
}

const VerificationFormComponent = ({
    onSubmitCode,
    invalidCode,
    dataTestId,
    maxTries,
}: {
    onSubmitCode: (values: IVerificationValuesProps) => void;
    invalidCode?: boolean;
    dataTestId: string;
    maxTries: boolean;
}) => {
    const initialValues: IVerificationValuesProps = {
        number1: '',
        number2: '',
        number3: '',
        number4: '',
        number5: '',
        number6: '',
    };
    const errorMessage =
        (invalidCode &&
            gettext(
                'This code is incorrect or expired. Resend a new code to try again.',
            )) ||
        (maxTries &&
            gettext(
                'You made 3 failed attempts. Check and update your email address, if necessary, and try again.',
            ));

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={VerificationSchema}
                onSubmit={onSubmitCode}
            >
                {({
                    values,
                    setFieldValue,
                    submitForm,
                }: any & IFormikActions) => (
                    <Form data-testid={dataTestId}>
                        <VerificationFormFields
                            values={values}
                            setFieldValue={setFieldValue}
                            submitForm={submitForm}
                            disabled={maxTries}
                        />
                    </Form>
                )}
            </Formik>
            {errorMessage && (
                <div className="eds-text-bs eds-text-color--error">
                    {errorMessage}
                </div>
            )}
        </>
    );
};

export default VerificationFormComponent;
